// Waiting on a <video>: the first picture after a start, and the next one after a pause.

/** The next painted frame of a playing video, or false after `ms`. */
export function nextFrame(video, ms) {
  return new Promise((resolve) => {
    let done = false;
    const t0 = video.currentTime;
    const finish = (ok) => {
      if (done) return;
      done = true;
      clearTimeout(cap);
      clearInterval(poll);
      resolve(ok);
    };
    const cap = setTimeout(() => finish(false), ms);
    const poll = setInterval(() => {
      if (!video.paused && video.videoWidth > 0 && video.currentTime > t0) finish(true);
    }, 80);
    video.requestVideoFrameCallback?.(() => finish(true));
  });
}

/** Resolves true when the video has put up a frame, false after `ms` (5 s) so it never hangs. */
export function firstFrame(video, ms = 5000) {
  // Whichever comes first: a painted frame, or the element playing with data.
  // A frame callback alone never fires for a video the browser is not
  // painting, which left Brave's working camera "not live" (10-28).
  return new Promise((resolve) => {
    let settled = false;
    const finish = (ok) => {
      if (settled) return;
      settled = true;
      clearTimeout(cap);
      clearInterval(poll);
      video.removeEventListener("playing", onPlaying);
      resolve(ok);
    };
    const cap = setTimeout(() => finish(false), ms);
    const onPlaying = () => finish(true);
    const poll = setInterval(() => {
      if (video.readyState >= 2 && !video.paused && video.videoWidth > 0) finish(true);
    }, 150);
    if (video.requestVideoFrameCallback) video.requestVideoFrameCallback(() => finish(true));
    video.addEventListener("playing", onPlaying);
  });
}
